import type { StyleProp } from '@vtex/admin-ui'
import { csx } from '@vtex/admin-ui'
import React from 'react'
import type { HTMLAttributes, ReactNode } from 'react'

import { sizeToRem } from '../../../../core/theme/theme'

const containerStyles: StyleProp = {
  fontSize: sizeToRem(4),
  fontWeight: 600,
}

export type SalesAssociateMovementsTrackingModalTitleProps = {
  csx?: StyleProp
  children: ReactNode
} & HTMLAttributes<HTMLDivElement>

export const SalesAssociateMovementsTrackingModalTitle = ({
  css,
  children,
  ...props
}: SalesAssociateMovementsTrackingModalTitleProps) => (
  <p className={csx({ ...containerStyles, ...csx })} {...props}>
    {children}
  </p>
)
